import {Component} from "@angular/core";
import {RouterOutlet} from "@angular/router";

//Composant principal
@Component (
{
  selector: 'val-root',
  imports: 
  [
    RouterOutlet
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent 
{
}
